import { render, staticRenderFns } from "./DeviceReportTableRefactored.vue?vue&type=template&id=013d331b&"
import script from "./DeviceReportTableRefactored.vue?vue&type=script&lang=js&"
export * from "./DeviceReportTableRefactored.vue?vue&type=script&lang=js&"
import style0 from "./DeviceReportTableRefactored.vue?vue&type=style&index=0&id=013d331b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports